import * as React from 'react';
import { useEffect, useState } from 'react';
import { TransProps, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { Breakpoint, ShippingBoxTheme } from '../../enums';
import { UseState } from '../../types';

import {
  AddressContainer,
  ButtonsContainer,
  Container,
  ShippingBoxContainer,
  SingleAddressContainer,
  StyledButton,
  Title
} from './shippingBox.styled';
import { ShippingBoxProps } from './shippingBox.types';

export const ShippingBox: React.FC<ShippingBoxProps> = (props: ShippingBoxProps): JSX.Element => {
  const { 
    onEditClick, 
    onRemoveClick, 
    onChangeClick, 
    boxTheme = ShippingBoxTheme.Light, 
    addressLines, 
    title,
    isActive,
    onBoxChoose,
    className 
  }: ShippingBoxProps = props;
  const { t }: TransProps<never> = useTranslation();
  const [active, setActive]: UseState<boolean | null> = useState<boolean | null>(isActive ?? null);
  const isSmallMobile: boolean = useMediaQuery({ query: Breakpoint.SmallMobile });

  useEffect(
    (): void => {
      if (isActive !== active && isActive !== undefined) {
        setActive(isActive);
      }
    },
    [isActive]
  );

  const setActiveBox: () => void = (): void => {
    if (onBoxChoose) {
      onBoxChoose(!active);
    }
    if (isActive === undefined) {
      setActive(!active);
    }
  };

  return (
    <Container 
      className={className} 
      onClick={active !== null ? setActiveBox : undefined} 
      $boxTheme={boxTheme} 
      $isActive={active ?? false}
    >
      <ShippingBoxContainer>
        <AddressContainer onClick={isSmallMobile ? onEditClick : undefined}>
          {!!title && <Title>{title}</Title>}
          {addressLines.map((address: string): JSX.Element => (
            <SingleAddressContainer key={address}>{address}</SingleAddressContainer>
          ))}
        </AddressContainer>
        <ButtonsContainer>
          {!!onChangeClick && (
            <StyledButton onClick={onChangeClick}>
              {t('onarte.ui.shippingBox.button.change')}
            </StyledButton>
          )}
          {!isSmallMobile && !!onEditClick && (
            <StyledButton onClick={onEditClick}>
              {t('onarte.ui.shippingBox.button.edit')}
            </StyledButton>
          )}
          {!!onRemoveClick && <StyledButton onClick={onRemoveClick}>{t('onarte.ui.shippingBox.button.remove')}</StyledButton>}
        </ButtonsContainer>
      </ShippingBoxContainer>
    </Container>
  );
};
